/* @ngInject */
export default function HauledModalController($uibModalInstance, prodDate) {
  const vm = this;
  vm.oilDelta = 0;
  vm.waterDelta = 0;
  vm.date = prodDate;
  vm.closeHauledAway = () => {
    $uibModalInstance.dismiss();
  };
  vm.save = () => {
    $uibModalInstance.close([vm.waterDelta, vm.oilDelta]);
  };
}
